import { useContext, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import { interfaces } from 'service/interfaces'
import Home from './Home'

const DialogEdit = (props) => {
  const {
    open,
    selectedConcept,
    handleClose,
    setSelectedConcept,
    tipoOblea,
    constants,
    setRender,
    render
  } = props
  const [edit, setEdit] = useContext(EditContext)

  const createDismissableSnackbar = useCustomSnackbar()
  const [loading, setLoading] = useState()
  
  const onUpdateConcept = async () => {
    setLoading(true)
    const id = selectedConcept?.id
    let obleaTipoId = selectedConcept.oblea_tipo

    if (typeof selectedConcept.oblea_tipo === "string") {
      const encontrado = tipoOblea.find(t => t.tipo === selectedConcept.oblea_tipo)
      if (encontrado) {
        obleaTipoId = encontrado.id
      }
    }

    const body  = {
      oblea_tipo: obleaTipoId,
      codigo: Number(selectedConcept.codigo),
      aplica_a: selectedConcept.aplica_a,
      requiere_control: selectedConcept.requiere_control,
      oblea_rudac: selectedConcept.oblea_rudac,
      combustible: selectedConcept.combustible,
      puertas: selectedConcept.puertas,
      traccion: selectedConcept.traccion,
      transmision: selectedConcept.transmision,
      turbo: selectedConcept.turbo
     }

    await interfaces.configInterface
      .updateWafers(id, body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        setRender(!render)
        setEdit(false)
        handleClose()
      })
      .catch((error) => {
        createDismissableSnackbar(error.response?.data?.data, {
          variant: "error",
        })
      }) 
    setLoading(false)
    handleClose()
    setEdit(false)
    setSelectedConcept(null)
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
            <Home
              concept={selectedConcept}
              tipoOblea={tipoOblea}
              setSelectedConcept={setSelectedConcept}
              edit={edit}
              constants={constants}
              loading={loading}
            />
        )
      case 1:
        return <ComplexDialogHistory history={selectedConcept?.historial} />
      default:
        break
    }
  }

  return (
    <ComplexDialog
      open={open}
      onClose={handleClose}
      tabs={horizontalTabs}
      title={`${selectedConcept?.oblea_rudac} - ID ${selectedConcept?.id}`}
      children={renderTabs}
      actions={
        <ComplexDialogActions
          onClose={handleClose}
          handleSubmit={onUpdateConcept}
          canEdit={selectedConcept?.canEdit}
          data={selectedConcept}
          editMode={true}
        />
      }
    />
  )
}

export default DialogEdit
